export const NETWORK = 'NETWORK'; // Сеть по всему дому
export const NETWORK_BY_SECTION = 'NETWORK_BY_SECTION'; // Сеть по секциям
export const SUBNET = 'SUBNET'; // Подсеть по всему дому
export const SUBNET_BY_SECTION = 'SUBNET_BY_SECTION'; // Подсеть по секциям
